/* import __COLOCATED_TEMPLATE__ from './head-tags.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();